var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 27,
    viewBox: "0 0 14 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.2789 26.8799C2.69383 26.8792 3.08868 26.7003 3.36251 26.3879L13.4766 14.8113C13.7082 14.5471 13.8359 14.2077 13.8359 13.8563C13.8359 13.5048 13.7082 13.1653 13.4766 12.901L3.36251 1.32457C3.01503 0.962482 2.50553 0.80675 2.01578 0.912359C1.52586 1.0183 1.12549 1.371 0.958441 1.84423C0.791061 2.31746 0.88061 2.84366 1.19512 3.23475L10.4713 13.8563L1.19512 24.4777C0.94957 24.7578 0.821358 25.1223 0.837258 25.4946C0.852992 25.867 1.01167 26.2191 1.28031 26.4772C1.54912 26.7354 1.90664 26.8797 2.2789 26.8799Z",
    className: "color5Fill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.6c5d8647bcc7e4028cc83d73a1510a1d.svg";
export { ForwardRef as ReactComponent };